//src/app/features/questionnaires/create/PrepareQuestionnaire/useFields.ts
import { commonFields, commonFieldsValidationSchema } from './fields';
import { useSelector } from 'react-redux';
import {
  businessFields,
  validationSchema as businessValidationSchema,
} from './fields/businessFields';
import {
  individualFields,
  validationSchema as individualValidationSchema,
} from './fields/individualFields';
import { selectPrepareQuestionnaire, TaxRequestType } from './slice';
import { useGetUserBusinessesQuery } from 'app/services/user';

export function getIndividualOrBusinessFields(
  serviceType: TaxRequestType | null,
  isSubscribed: boolean,
) {
  if (isSubscribed) {
    return {
      fields: [commonFields.find((field) => field.name === 'year')!],
      validationSchema: commonFieldsValidationSchema,
    };
  }
  return serviceType === TaxRequestType.Business
    ? { fields: businessFields, validationSchema: businessValidationSchema }
    : serviceType === TaxRequestType.Individual
    ? {
        fields: individualFields,
        validationSchema: individualValidationSchema,
      }
    : { fields: commonFields, validationSchema: commonFieldsValidationSchema };
}

// src/app/features/questionnaires/create/PrepareQuestionnaire/useFields.ts
export function useFields() {
  const taxRequestTarget = useSelector(selectPrepareQuestionnaire);
  const { data: businesses } = useGetUserBusinessesQuery();
  const selectedBusiness = businesses?.find(
    (b) => b.id.toString() === taxRequestTarget.businessId?.toString(),
  );

  const isSubscribed = selectedBusiness?.subscribed?.TAX || false;
  const serviceType = taxRequestTarget.taxRequestType;

  const { fields, validationSchema } = getIndividualOrBusinessFields(
    serviceType,
    isSubscribed,
  );

  const subscriptionLabel = isSubscribed
    ? 'Your business is already subscribed with us, we have minimized the questions for you.'
    : null;

  return { fields, validationSchema, subscriptionLabel, isSubscribed };
}
